import { render, staticRenderFns } from "./TariffProgress.vue?vue&type=template&id=06725892&scoped=true&"
import script from "./TariffProgress.vue?vue&type=script&lang=js&"
export * from "./TariffProgress.vue?vue&type=script&lang=js&"
import style0 from "./TariffProgress.vue?vue&type=style&index=0&id=06725892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06725892",
  null
  
)

export default component.exports